import React, {useState} from 'react';
import styles from "../../assets/stylesheets/sass/Button.module.scss";

export default function Button({value, state, onClick, disabled}){


  return (
    <>
    <button disabled={disabled} onClick={(e)=>onClick(e)} className={state === "inactive" ? styles.btn_general_inactive : state==="active-green" ? styles.btn_general_green : state === "active-error" ? styles.btn_general_red : styles.btn_general}><span>{value}</span></button>
    </>
  )
}